// extracted by mini-css-extract-plugin
export default {"container":"Services_container__jpFJC","small":"Services_small__Lo0dA","big":"Services_big__buyOz","left_marg":"Services_left_marg__xHe1n","right_marg":"Services_right_marg__P+WGm"};